import {ChangeDetectionStrategy, Component} from '@angular/core';
import {CarsComponent} from '../cars/cars.component';

@Component({
    selector: 'app-cars-external',
    templateUrl: '../cars/cars.component.html',
    styleUrls: ['../cars/cars.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CarsExternalComponent extends CarsComponent {
    protected override externalCars = true;
}
